export const products = [
  {
    id: 'prod_SBjZbJh0COTS88',
    priceId: 'price_1RHM6b07OjCSOwCF2goKyE77',
    name: 'סרום ניאצינמיד 5% Niacinamide Serum',
    description: 'סרום אנטי-אייג\'ינג לבעיות עור – מצמצם נקבוביות, מאזן שומן, מבהיר גוון.',
    mode: 'payment',
    price: 460,
    currency: 'ILS',
    image: '/images/niacinamide-serum.jpg',
  },
  {
    id: 'prod_SBjZrsCPgwJVwN',
    priceId: 'price_1RHM6907OjCSOwCFKd8hoGnJ',
    name: 'קצף ניקוי תלת-פעולה Three Action Foam',
    description: 'קצף ניקוי עם 3 חומצות פעילות – גליקולית, לקטית וסליצילית. מנקה לעומק ומותאם לעור רגיש.',
    mode: 'payment',
    price: 190,
    currency: 'ILS',
    image: '/images/three-action-foam.jpg',
  },
  {
    id: 'prod_SBjYrKaarm3Pnf',
    priceId: 'price_1RHM5b07OjCSOwCFPUtQ2T4n',
    name: 'קרם רטינול R.E.T.I.N.A Active',
    description: 'קרם לילה מתקדם עם רטינול 2% – מבהיר, מחדש ומחליק את העור.',
    mode: 'payment',
    price: 460,
    currency: 'EUR',
    image: '/images/retina-active.jpg',
  },
  {
    id: 'prod_SBjYQZmh5jiS14',
    priceId: 'price_1RHM5C07OjCSOwCF6wGSnofY',
    name: 'קרם הבהרה Giga White',
    description: 'קרם הבהרה חזק עם קומפלקס GigaWhite וחומצה ארבוטין – ללא חומרים מזיקים.',
    mode: 'payment',
    price: 318,
    currency: 'ILS',
    image: '/images/giga-white.jpg',
  },
  {
    id: 'prod_SBjXVyM6eJxmgQ',
    priceId: 'price_1RHM4j07OjCSOwCFnhBTtFte',
    name: 'סרום לחות Mezoenergizer Hyaluronic Serum',
    description: 'סרום חומצה היאלורונית להזנה עמוקה של העור, עם תמצית תפוח ונרקיס.',
    mode: 'payment',
    price: 375,
    currency: 'ILS',
    image: '/images/hyaluronic-serum.jpg',
  },
  {
    id: 'prod_SBjXitbxIBYDh5',
    priceId: 'price_1RHM4J07OjCSOwCFNLpzTd2I',
    name: 'קרם הגנה BB עם SPF 30',
    description: 'קרם יום קליל המשלב לחות עם מקדם הגנה SPF 30, משתלב עם גוון העור.',
    mode: 'payment',
    price: 185,
    currency: 'ILS',
    image: '/images/bb-cream-spf30.jpg',
  },
  {
    id: 'prod_SBjWHW63dSIGp5',
    priceId: 'price_1RHM3907OjCSOwCFMLngSPVe',
    name: 'ג\'ל עיניים Complex Eye Gel',
    description: 'ג\'ל עיניים פעיל עם תמציות שורש, נרקיס וזרעי ניקולאי. יתרונות: הפחתת כהויות סביב העיניים, מיצוק והזנת האזור, הפחתת קמטים ונפיחויות',
    mode: 'payment',
    price: 305,
    currency: 'ILS',
    image: '/images/eye-gel.jpg',
  },
];
